import { Pipe, PipeTransform } from '@angular/core'

const THREE_FIXED = 3
const TWO_FIXED = 2 //avoiding eslint magic numbers error
const LAST_INDEX = -1
const START_INDEX = 0
@Pipe({
  name: 'VMFPercent',
})
export class VmfPercentPipe implements PipeTransform {
  transform(value: string, isExpense?: boolean): string {
    if (value != null) {
      if (isExpense) {
        const result = parseFloat(value.toString()).toFixed(THREE_FIXED)
        return result.slice(LAST_INDEX) === '0'
          ? result.slice(START_INDEX, LAST_INDEX).concat('%')
          : result.concat('%')
      } else {
        const result = parseFloat(value.toString()).toFixed(TWO_FIXED)
        return result.concat('%')
      }
    }
    return '—'
  }
}
